// extracted by mini-css-extract-plugin
export default {"wrapper":"Button_wrapper__GqKsN","primary":"Button_primary__9MLUH"};